import { inject, IEventAggregator } from 'aurelia';
import { SubmitApplication } from '../../messages/submit-application';

@inject(Element, IEventAggregator)
export class SubmitApplicationCustomAttribute {
  constructor(element, ea) {
    this.element = element;
    this.ea = ea;
    this.onClick = (event) => {
      event.preventDefault();
      this.ea.publish(new SubmitApplication());
    };
  }

  attached() {
    this.element.addEventListener('click', this.onClick);
  }

  detaching() {
    this.element.removeEventListener('click', this.onClick);
  }
}
